import { handleApiErrorResponse } from "../lib/helpers";

export function createProjectService(formData, token) {
    return fetch(process.env.REACT_APP_API_END_POINT + "workspaceprojects/create", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getWorkspaceProjectsService(formValues, token, signal) {
    const query = new URLSearchParams({
        workspace_id: formValues.workspace_id,
        search: formValues.search || "",
        page: formValues.page || 1,
        limit: formValues.limit || 10,
    }).toString();

    return fetch(
        process.env.REACT_APP_IMG_URL + `api/v2/researcher/workspaces/projects?${query}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getWorkspaceTestsService(formValues, token, signal) {
    const query = new URLSearchParams({
        workspace_id: formValues.workspace_id,
        status: formValues.status || "",
        methodology: formValues.methodology || "",
        search: formValues.search || "",
        order: formValues.order || "desc",
        page: formValues.page || 1,
        limit: formValues.limit || 10,
    }).toString();

    return fetch(
        process.env.REACT_APP_IMG_URL + `api/v2/researcher/workspaces/tests?${query}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getAllWorkspaceProjectsService(formValues, token, signal) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "workspaceprojects/list/all?workspace_id=" +
        formValues.workspace_id,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function deleteProjectService(formData, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT + "workspaceprojects/delete-project",
        {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function pinProjectService(formData, token) {
    return fetch(process.env.REACT_APP_API_END_POINT + "workspaceprojects/pin", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function unpinProjectService(formData, token) {
    return fetch(process.env.REACT_APP_API_END_POINT + "workspaceprojects/unpin", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function updateProjectService(formData, token) {
    return fetch(process.env.REACT_APP_API_END_POINT + "workspaceprojects/update", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getWorkspaceProjectService(token, projectId) {
    return fetch(
        `${process.env.REACT_APP_IMG_URL}api/v2/researcher/workspaces/projects/get?project_id=${projectId}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function moveTestService(formData, token) {
    return fetch(process.env.REACT_APP_API_END_POINT + "workspaceprojects/move", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((res) => {
            const isJson = res.headers.get("content-type")?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}